import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { getPqrStatusBadgeVariant, getPqrStatusTranslationKey } from "@/features/pqr/pqrMappers";
import type { PqrStatus } from "@/features/pqr/pqr.types";

type StatusBadgeProps = {
  status: PqrStatus;
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <Badge variant={getPqrStatusBadgeVariant(status)}>
      {t(getPqrStatusTranslationKey(status))}
    </Badge>
  );
}
